import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { FilterIcons } from "views/Secure/Home/Content/Filters/GroupedFilters/Filter";
import { IGrade } from "../common/Interfaces";

export interface IFilter {
  icon?: FilterIcons;
  code: string;
  title: string;
}
export interface ILevelFilter extends IFilter {
  subGroups?: IFilter[];
}

export interface ILevelMoeFilter extends IFilter {
  groups?: ILevelFilter[];
}

interface IGradeLessonsFilters {
  moe: ILevelMoeFilter[];
  domains: ILevelFilter[];
}

export interface ILessonsFilters {
  [key: number]: IGradeLessonsFilters;
}

interface IFiltersState {
  grades: IGrade[];
  lessonsFilters: ILessonsFilters;
  freePlayFilters: ILevelFilter[];
  guidedReadingFilters: ILevelFilter[];
}

const initialState: IFiltersState = {
  grades: [],
  lessonsFilters: {},
  freePlayFilters: [],
  guidedReadingFilters: [],
};
export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    filtersLoaded(state: IFiltersState, action: PayloadAction<IFiltersState>) {
      state.grades = action.payload.grades;
      state.lessonsFilters = action.payload.lessonsFilters;
      state.freePlayFilters = action.payload.freePlayFilters;
      state.guidedReadingFilters = action.payload.guidedReadingFilters;
    },
  },
});

export const selectGrades = (state: RootState) => state.filters.grades;
export const selectLessonsFilters = (state: RootState) =>
  state.filters.lessonsFilters;
export const selectFreePlayFilters = (state: RootState) =>
  state.filters.freePlayFilters;
export const selectGuidedReadingFilters = (state: RootState) =>
  state.filters.guidedReadingFilters;

export const { filtersLoaded } = filtersSlice.actions;

export default filtersSlice.reducer;
